import { createActions, createReducer } from 'reduxsauce';

// const {
//   PPT_STATUS: { PLAY },
// } = CONST;

// Define Action
const { Types, Creators } = createActions({
  // 更新教案文件信息
  updateFileData: ['fileId', 'fileType', 'current'],
  play: null,
  exit: null,
  // 更新教案状态（PPT播放&退出播放）
  updateStatus: ['status'],
  updateClassroomInfo: ['classroomId'],
  getResourceStatus: ['contentId', 'contentType'],
  getResourceStatusSuccess: null,
});

export const Creator = Creators;
export const Type = Types;

// Define Initial State
const INITIAL_STATE = {
  // 文件id
  fileId: '',
  // 文件类型
  fileType: '',
  // 当前页码
  current: 1,
  // PPT播放状态
  status: 'play',
  classroomId: '',
  resourceStatus: '',
};

// Define Reducer
export default createReducer(INITIAL_STATE, {
  [Types.UPDATE_FILE_DATA]: (state = INITIAL_STATE, action) => {
    return {
      ...state,
      fileId: action.fileId,
      fileType: action.fileType,
      current: action.current,
    };
  },
  [Types.PLAY]: (state = INITIAL_STATE) => ({
    ...state,
    status: 'play',
  }),
  [Types.EXIT]: (state = INITIAL_STATE) => ({
    ...state,
    status: 'preview',
  }),
  [Types.UPDATE_STATUS]: (state = INITIAL_STATE, action) => ({
    ...state,
    status: action.status,
  }),
  [Types.UPDATE_CLASSROOM_INFO]: (state = INITIAL_STATE, action) => ({
    ...state,
    classroomId: action.classroomId,
  }),
  [Types.GET_RESOURCE_STATUS_SUCCESS]: (state = INITIAL_STATE, action) => ({
    ...state,
    resourceStatus: action.resourceStatus,
  }),
});
